import { jsx } from 'react/jsx-runtime';
import { createSVG } from '../../utils/createSVG/createSVG/index.js';

const IconTextTry = createSVG({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M36.416 5.999h2.675l-4.115 7.321v4.681h-2.349v-4.681l-4.098-7.321h2.675l2.606 5.006 2.606-5.006z M25.644 18.001h2.555l-2.658-4.526c1.372-0.634 2.315-1.989 2.315-3.498 0-2.195-1.783-3.978-3.995-3.978h-4.801v12.002h2.366v-4.166h1.8l2.418 4.166zM21.426 8.211h2.435c0.892 0 1.629 0.772 1.629 1.766s-0.737 1.783-1.629 1.783h-2.435v-3.549z M8.91 5.999h8.83v2.263h-3.24v9.738h-2.366v-9.738h-3.223v-2.263z" }),
    width: 48,
});

export { IconTextTry };
